<template>
    <div class="content">
        <div>
            <JsonExcel :fields="exportDataStandard" :data="exportData" type="xls" name="操作记录" :fetch="createExportData" :before-finish="finishDownload" worksheet="操作记录">
                <el-button type="primary" class="el-icon-download"> 导出</el-button>
            </JsonExcel>
          </div>

        <el-card style="margin-top:15px;width:100%;height: 60px;display: flex;align-items: center;" class="box-card">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="12" :md="12" :lg="8">
                    <div class="search">
                        <label>时间：</label>
                        <el-date-picker v-model="searchForm.time" type="datetimerange" range-separator="-" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="6">
                    <div class="search">
                        <label>车牌号：</label>
                        <el-input v-model="searchForm.plateno" class="marg" style="max-width: 200px;"></el-input>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="6">
                    <div class="search">
                        <label>通道：</label>
                        <el-select v-model="searchForm.gt_id" style="width:150px" @change="parkChanged">
                            <el-option label="全部" :value="0"></el-option>
                           <el-option v-for="item in GateList" :key="item.gt_id" :label="item.gt_name" :value="item.gt_id"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col v-if="User.user_type!==5"  :xs="24" :sm="12" :md="12" :lg="4">
                    <div class="search">
                    <label>车场：</label>
                    <el-select v-model="searchForm.pk_id" style="width:150px" @change="parkChanged">
                        <el-option v-if="User.user_type===5" label="全部" :value="0"></el-option>
                        <el-option v-for="item in ParkDataList" :key="item.pk_id" :label="item.pk_name" :value="item.pk_id"></el-option>
                    </el-select>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="8" :md="4" :lg="2">
                    <div class="search">
                        <el-button type="primary" plain @click="Search">查询</el-button>
                    </div>
                </el-col>
            </el-row>
        </el-card>

          <el-table :data='DataList' border style="width: 100%;font-size:13px" max-height='calc(100vh - 300px)' height='calc(100vh - 300px)' stripe :highlight-current-row='true' size="mini">
            <el-table-column v-if="User.user_type!==5" align="center" prop="park_name" label="所属车场">
                <template slot-scope="scope">
                    <span class="table-font">{{scope.row.park_name}}</span>
                  </template>
            </el-table-column>
            <el-table-column align="center" prop="log_time" label="时间">
                <template slot-scope="scope">
                    <span class="table-font"> {{FormData(scope.row.log_time)}}</span>
                  </template>
            </el-table-column>
            <el-table-column align="center" prop="log_plateno" label="车牌号">
                <template slot-scope="scope">
                    <span class="table-font">{{scope.row.log_plateno}}</span>
                  </template>
            </el-table-column>
            <el-table-column align="center" prop="gt_name" label="通道">
                <template slot-scope="scope">
                    <span class="table-font">{{scope.row.gt_name}}</span>
                  </template>
            </el-table-column>
            <el-table-column align="center" prop="log_msg" label="描述">
                <template slot-scope="scope">
                    <span class="table-font">{{scope.row.log_msg}}</span>
                  </template>
            </el-table-column>
          </el-table>
          <el-pagination style="width:100%" layout="sizes,prev, pager, next" :page-sizes="[15, 30, 45, 60]" @current-change="current_change" :total="searchForm.total" background :page-size="searchForm.pageSize" @size-change="handleSizeChange"></el-pagination>
  
    </div>
</template>


<script>
import util from '../../../util/util'
import JsonExcel from 'vue-json-excel'

export default{
    data:function(){
        return{
            User:null,
                searchForm:{
                    pageNo:1,
                    pageSize:15,
                    total:0,
                    pk_id:0,
                    time:[],
                    gt_id:0,
                    plateno:''
                },
                ParkDataList:[],
                GateList:[],
                DataList:[],

                exportDataStandard: {
                    所属车场: "park_name" ,
                    时间: {
                        field: 'log_time',
                        callback: value => {
                        return this.FormData(value)
                        }
                    },
                    车牌号: "log_plateno" ,
                    通道:"gt_name",
                    描述:'log_msg'
                },
                exportData: []
        }
    },
    components: {
        JsonExcel
    },
    computed: {
        FormData () {
            return function (time) {
                if(time===null||time===undefined||time==='')
                    return ''
                else
                    return util.FormateDate(time, 2)
            }
        },
    },
    created(){
        this.User = util.JesToken()
        this.getParkDataList()
    },
    methods:{
        getParkDataList(){
            if(this.User.user_type===5){
                this.getChannelList()
                this.GetDataList()
            }
            else{
                util.Get('parkmanage/getparkdatalist').then(res => {
                    if (res.rpStatus === 10000) {
                        this.ParkDataList = res.list
                        if(res.list.length>0){
                            this.searchForm.pk_id=res.list[0].pk_id
                            this.getChannelList()
                            this.GetDataList()
                        }
                    }
                })
            }
        },
        parkChanged(value){
            this.searchForm.pk_id=value
            this.searchForm.gt_id=0
            this.getChannelList()
            this.GetDataList()
        },
        getChannelList(){
            util.Get('gate/getgatedatalist?id='+this.searchForm.pk_id).then(res=>{
                if(res.rpStatus===10000){
                    this.GateList=res.list[4]
                }
            })
        },


        GetDataList () {
            if (this.searchForm.time === null || this.searchForm.time.length === 0) {
                this.searchForm.begintime = ''
                this.searchForm.endtime = ''
            } else {
                this.searchForm.begintime = this.searchForm.time[0]
                this.searchForm.endtime = this.searchForm.time[1]
            }
            util.Get('loginoutmessage/getlogdataList', this.searchForm).then(res => {
                console.log(res)
                if (res.rpStatus === 10000) {
                    this.DataList = res.list
                    this.searchForm.total = res.total
                }
            })
        },
        Search () {
            this.searchForm.pageNo=1
            this.GetDataList()
        },



        current_change (page) {
            this.searchForm.pageNo = page
            this.GetDataList()
        },
        handleSizeChange(pageSize){
            this.searchForm.pageSize=pageSize
            this.GetDataList()
        },
        // 导出
        async createExportData () {
            this.searchForm.pageNo = 0
            var form = JSON.parse(JSON.stringify(this.searchForm))
            form.pageNo = 0

            var result = await util.Get('loginoutmessage/getlogdataList', form)
            if (result.rpStatus === 10000) {
                this.exportData = result.list
                return this.exportData
            }
        },
        finishDownload () {
            this.$message({
                message: '导出数据成功',
                type: 'success'
            })
            this.exportData=[]
        }
    }
}

</script>


<style scoped>
    @import '../../../assets/css/font.css';
.content{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
}
.search{
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 13px;
}
.search label{
  margin-right: 8px;
  width: 80px;
  text-align: right;
}
.el-table{
    margin-top: 10px;
}
::v-deep.el-table thead {
  color: #666666;
  font-weight: 500;
}
</style>